import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { CaseService } from 'app/cm/services/case-service';
import { Toaster } from 'app/shared/lib/toaster';
import { apiCall } from 'app/shared/lib/essette-api';
import * as CM from 'app/cm/models/essette-api';

@autoinject()
export class SaveCaseQueue extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////
    @bindable.objectNull({ defaultBindingMode: bindingMode.toView })
    protected queue: CM.CaseQueue | null = null;

    protected maxDescriptionLength: number = 30;
    protected maxCodeLength: number = 50;


    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: CaseService,
        private readonly toaster: Toaster,
        ...rest: any[]) {
        super(...rest);
    }

    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////
    protected constructSaveObject(): CM.CaseQueue {
        if(!this.queue) {
            throw new Error('Bindable property "queue" must be bound');
        }

        const saveQueue: CM.CaseQueue = {
            id: this.queue.id,
            description: this.queue.description,
            code: this.queue.code,
            daysToComplete: this.queue.daysToComplete
        };

        return saveQueue;
    }

    public reset(): void {
        this.queue = null;
    }

    public async submit(): Promise<boolean> {
        return await this.saveQueue();
    }

    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    private async saveQueue(): Promise<boolean> {
        let isSuccessful = false;
        try {
            this.state.beginSave();

            const response = await this.service.insertQueue(this.constructSaveObject());
            isSuccessful = response.isSuccessful;
            return isSuccessful;
        } catch(error) {
            throw error;
        } finally {
            this.toaster.standard.saved('cm:queue.$long', isSuccessful);
            this.state.endSave();
        }
    }
}
